import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-245" data-mp="8t38tvsza2vl">
      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/6df5644c-2472-4ba3-85fd-cd40288deae1/ChatGPT_Image_Apr_27,_2026,_02_44_47_PM.png" alt="Author Leverage Logo" className="h-10 w-auto object-contain drop-shadow-sm" data-id="element-246" data-mp="8ue9hmr4muih" />
      
      <span className="font-serif font-semibold text-navy text-2xl tracking-tight" data-id="element-247" data-mp="mu5sk1wi313c">
        Author Leverage
      </span>
    </div>;
}